import { render, staticRenderFns } from "./news-banner.vue?vue&type=template&id=5cece4c7&scoped=true&"
import script from "./news-banner.vue?vue&type=script&lang=js&"
export * from "./news-banner.vue?vue&type=script&lang=js&"
import style0 from "./news-banner.vue?vue&type=style&index=0&id=5cece4c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cece4c7",
  null
  
)

export default component.exports